import { render, staticRenderFns } from "./deletePromo.vue?vue&type=template&id=74b4237a"
import script from "./deletePromo.vue?vue&type=script&lang=js"
export * from "./deletePromo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports